import Button from "../Button/Button";
import Typography from "../Typography/Typography";
import { CircleFadingArrowUp, Cog, Library, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../store/AuthContext/AuthContext";
import { useEffect, useState, useRef } from "react";

export default function LandingHeader({
  isBeta,
  setHeaderHeight,
  headerHeight,
}) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const headerRef = useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const controlNavbar = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY) {
      // Scroll verso il basso - nascondi solo se scroll > altezza header
      if (currentScrollY > headerHeight) {
        setVisible(false);
      }
    } else {
      // Scroll verso l'alto - mostra sempre
      setVisible(true);
    }
    setLastScrollY(currentScrollY);
  };

  // Aggiorna l'altezza dell'header nel componente genitore
  const updateHeaderHeight = () => {
    if (headerRef.current && setHeaderHeight) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    // Imposta l'altezza iniziale
    updateHeaderHeight();
    // Aggiungi event listener per lo scroll
    window.addEventListener("scroll", controlNavbar);
    // Aggiungi event listener per il resize
    window.addEventListener("resize", updateHeaderHeight);

    // Blocca lo scroll quando il menu mobile è aperto
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup
    return () => {
      window.removeEventListener("scroll", controlNavbar);
      window.removeEventListener("resize", updateHeaderHeight);
      document.body.style.overflow = "auto";
    };
  }, [lastScrollY, mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <>
      <header
        ref={headerRef}
        className={`sticky top-0 z-50 w-full transition-transform duration-300 bg-white border-b-2 border-gray-100 ${
          visible ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="flex items-center justify-between px-5 py-4">
          <div className="flex items-center gap-4">
            <Link to="/">
              <img
                className="md:w-40 w-24"
                src="/assets/images/logo/lockup.svg"
                alt="Athena Logo"
              />
            </Link>
            {isBeta && (
              <div className="flex px-3 py-1 bg-accent rounded-[4px]">
                <Typography size="12" weight="sb" color="white">
                  BETA
                </Typography>
              </div>
            )}
          </div>

          <div className="hidden md:flex items-center space-x-6">
            <Button
              variant="color"
              onClick={() => {
                navigate("/login");
                toggleMobileMenu();
              }}
              text="Accedi"
              width="fit"
            />
          </div>

          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="p-2 focus:outline-none"
            >
              <Menu size={24} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile menu - slide up from bottom */}
      <div
        className={`fixed inset-0 bg-gray-50 z-50 transition-transform duration-300 ease-in-out ${
          mobileMenuOpen ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex justify-between items-center p-4 border-b-2 border-gray-100 bg-white">
            <div className="flex items-center gap-4">
              <Link to="/">
                <img
                  className="md:w-40 w-24"
                  src="assets/images/logo/lockup.svg"
                  alt="Athena Logo"
                />
              </Link>
              {isBeta && (
                <div className="flex px-3 py-1 bg-accent rounded-[4px]">
                  <Typography size="12" weight="sb" color="white">
                    BETA
                  </Typography>
                </div>
              )}
            </div>
            <button
              onClick={toggleMobileMenu}
              className="p-2 focus:outline-none"
            >
              <X size={24} />
            </button>
          </div>

          <div className="flex flex-col flex-grow p-6 space-y-6">
            <Link to="/" onClick={toggleMobileMenu}>
              <Typography size="24" weight="md">
                Home
              </Typography>
            </Link>

            <Link to="/blog" onClick={toggleMobileMenu}>
              <Typography size="24" weight="md">
                Blog
              </Typography>
            </Link>
            <Link to="/pricing" onClick={toggleMobileMenu}>
              <Typography size="24" weight="md">
                Prezzi
              </Typography>
            </Link>
            <Link to="/legal/terms" onClick={toggleMobileMenu}>
              <Typography size="24" weight="md">
                Termini
              </Typography>
            </Link>
          </div>

          <div className="flex flex-col gap-0 p-6">
            <div className="px-8 pt-8 -mb-14">
              <img
                src="assets/images/illustrations/celebrating.png"
                alt="Landing Illustration"
              />
            </div>
            <Button
              variant="color"
              onClick={() => {
                navigate("/login");
                toggleMobileMenu();
              }}
              text="Accedi"
              width="full"
            />
          </div>
        </div>
      </div>
    </>
  );
}
